import React, { useState } from "react";
import { withStyles } from "@mui/styles";
import { Typography } from "@mui/material";

import Button from "../../components/button/Button";
import ErrorMessage from "../../components/errorMessage/ErrorMessage";

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
  invitationContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    margin: "20px 0",
    wordBreak: "break-all",
  },
  infoText: {
    marginBottom: "10px",
    color: "#333",
  },
  urlBox: {
    backgroundColor: "#f5f5f5",
    padding: "10px",
    borderRadius: "4px",
    flexGrow: 1,
  },
});

function EditUserEmailForm({
  classes,
  payload,
  onSubmit,
  errorMessage,
  submitting,
  onResendInvitationEmail,
  resendingInvitationEmail,
  invitationUrl,
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (invitationUrl) {
      await navigator.clipboard.writeText(invitationUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className={classes.section}>
      <Typography
        variant="h5"
        id="update-member-title"
        sx={{ marginBottom: "10px" }}
      >
        Resend Invitation Email
      </Typography>
      <div className={classes.infoText}>
        Please double-check that the email address{" "}
        <strong>{payload.emailAddress}</strong> is correct. Ask the member to
        also check their junk or spam inbox.
      </div>

      {invitationUrl && invitationUrl.length > 45 && (
        <div className={classes.infoText}>
          If they are not receiving the email from Slate, you can copy the
          invitation link and send to them directly.
        </div>
      )}

      {invitationUrl && invitationUrl.length > 45 && (
        <div className={classes.invitationContainer}>
          <div className={classes.urlBox}>{invitationUrl}</div>
          <Button title={copied ? "Copied!" : "Copy"} onClick={handleCopy} />
        </div>
      )}

      <div className={classes.infoText} style={{ marginTop: "40px" }}>
        Click the button below to send a new invitation email from Slate.
      </div>

      <Button
        title="RESEND INVITATION EMAIL"
        onClick={() => onResendInvitationEmail(payload)}
        submitting={resendingInvitationEmail}
        style={{
          minWidth: "221.328px",
          marginBottom: "20px",
        }}
      />
      <ErrorMessage message={errorMessage} />
      {onSubmit && (
        <Button
          title="Done"
          onClick={() => {
            onSubmit(payload);
          }}
          submitting={submitting}
        />
      )}
    </div>
  );
}

export default withStyles(styles)(EditUserEmailForm);
